import { useTranslation } from 'react-i18next';
import { LegalShell, LegalLead, LegalP } from './LegalPages';

export function OpenSourcePage() {
  const { t } = useTranslation();

  const rows = [
    { lib: 'NestJS', version: '10.x', license: 'MIT', use: t('open_source.nestjs_use') },
    { lib: 'React', version: '18.x', license: 'MIT', use: t('open_source.react_use') },
    { lib: 'Vite', version: '5.x', license: 'MIT', use: t('open_source.vite_use') },
    { lib: 'Tailwind CSS', version: '3.x', license: 'MIT', use: t('open_source.tailwind_use') },
    { lib: 'pg', version: '8.x', license: 'MIT', use: t('open_source.pg_use') },
    { lib: 'Tesseract.js', version: '7.x', license: 'Apache 2.0', use: t('open_source.tesseract_use') },
    { lib: 'bcryptjs', version: '3.x', license: 'MIT', use: t('open_source.bcrypt_use') },
    { lib: 'passport-google-oauth20 · passport-apple', version: '—', license: 'MIT', use: t('open_source.passport_use') },
    { lib: 'echarts', version: '5.x', license: 'Apache 2.0', use: t('open_source.echarts_use') },
    { lib: 'framer-motion', version: '12.x', license: 'MIT', use: t('open_source.framer_use') },
    { lib: 'i18next', version: '23.x', license: 'MIT', use: t('open_source.i18next_use') },
    { lib: 'lucide-react', version: '0.344', license: 'ISC', use: t('open_source.lucide_use') },
    { lib: 'date-fns', version: '3.x', license: 'MIT', use: t('open_source.datefns_use') },
  ];

  return (
    <LegalShell titleKey="open_source.title">
      <LegalLead>{t('open_source.lead')}</LegalLead>

      <div className="mt-6 overflow-x-auto border border-ink-200">
        <table className="w-full text-[13px] border-collapse">
          <thead>
            <tr className="bg-ink-50 border-b border-ink-200">
              <th className="px-4 py-3 text-left text-xs uppercase tracking-wide text-ink-600 font-medium">{t('open_source.col_library')}</th>
              <th className="px-4 py-3 text-left text-xs uppercase tracking-wide text-ink-600 font-medium">{t('open_source.col_version')}</th>
              <th className="px-4 py-3 text-left text-xs uppercase tracking-wide text-ink-600 font-medium">{t('open_source.col_license')}</th>
              <th className="px-4 py-3 text-left text-xs uppercase tracking-wide text-ink-600 font-medium">{t('open_source.col_use')}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.lib} className="border-b border-ink-200 last:border-b-0 align-top">
                <td className="px-4 py-3 font-semibold text-ink-900 font-mono">{r.lib}</td>
                <td className="px-4 py-3 text-ink-700 font-mono">{r.version}</td>
                <td className="px-4 py-3 text-ink-700 font-mono">{r.license}</td>
                <td className="px-4 py-3 text-ink-700">{r.use}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <LegalP>{t('open_source.closing_note')}</LegalP>
    </LegalShell>
  );
}
